// Libraries
import { Box, Link } from "@material-ui/core";
import { useObserver } from "mobx-react-lite";
import React from "react";

// Custom
import { DelcoteProductsStyle } from "./DelcoteProductsStyle";

import { DelcoteGS } from "./DelcoteSubViews/DelcoteGS";

import { DelcoteProductsViewModel } from "Custom/ViewModels/ProductSelector/SubViewModels/GutterSystemSubViewModels/DelcoteProductsViewModel";
import { ProductsCommonViewModel } from "Custom/ViewModels/ProductSelector/SubViewModels/GutterSystemSubViewModels/ProductsCommonViewModel";

interface IProps {
    className?: string;
    commonViewModel: ProductsCommonViewModel;
    viewModel: DelcoteProductsViewModel;
}

export const DelcoteProducts: React.FC<IProps> = (props: IProps) => {
    // #region Code Behind

    const delcoteProductsStyle = DelcoteProductsStyle();

    // #endregion Code Behind

    // #region Render Result

    return useObserver(() => (
        <Box className={delcoteProductsStyle.root}>
            <Box className={delcoteProductsStyle.specificationLink}>
                <Link href="https://www.hdsharman.co.uk/wp-content/uploads/2021/05/Delcote-GS-Specification-V4May2021.pdf" target="_blank">
                    View system specification
                </Link>
            </Box>
            <Box>{props.viewModel.canDisplaySubstrateUndefined && <DelcoteGS commonViewModel={props.commonViewModel} viewModel={props.viewModel.DelcoteGSViewModel} />}</Box>
        </Box>
    ));

    // #endregion Render Result
};
